var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex_color", attrs: { id: "color" } }, [
    _c("div", { staticClass: "color_title text_size_middle bold" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "color_name" }, [_vm._v(_vm._s(_vm.color.name))]),
    _vm._v(" "),
    _c("div", { staticClass: "color_img" }, [
      _vm.color.imgB !== undefined
        ? _c("img", { attrs: { src: _vm.color.imgB } })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-254e9247", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254e9247","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/top/input/color/DcColorForCart.vue
// module id = null
// module chunks = 